import { Box, Skeleton, Typography } from '@mui/material';
import { formatDollarAmount } from '../../utils/global/helper';

type Props = {
  metric: number | undefined;
  name: string;
  type: 'number' | 'dollar';
  isLoading?: boolean;
  small?: boolean;
};

export default function MetricCard({
  metric,
  name,
  type,
  isLoading,
  small = false,
}: Props) {
  return (
    <Box
      style={{ flexGrow: 1 }}
      display="flex"
      flexDirection="column"
      gap={small ? '2px' : '4px'}>
      {typeof metric === 'number' && !isLoading ? (
        <>
          <Typography variant="body2" textAlign="center" component="p">
            {name}
          </Typography>
          <Typography
            variant="h1"
            fontWeight={900}
            textAlign="center"
            component="p"
            fontSize={
              small ? theme => theme.typography.h2.fontSize : undefined
            }>
            {type === 'dollar' ? formatDollarAmount(metric) : metric}
          </Typography>
        </>
      ) : (
        <Skeleton width="60%" height={54} /> // 54px is the height of the card content - prevents layout shift
      )}
    </Box>
  );
}
